import { Component, OnDestroy, Input, AfterViewInit, OnChanges, SimpleChanges, HostListener, isDevMode } from '@angular/core';
import { interval, Subscription, timeout, timestamp } from 'rxjs';
import { AppConfig } from 'src/app/domain/appconfig';
import { Shipment } from 'src/app/domain/Shipment';
import { ConfigService } from 'src/app/services/app.config.service';
import { AuthService } from 'src/app/services/auth.service';
import { PriceFeatchStatus, ShipmentService } from 'src/app/services/shipment.service';
import { StepperService } from '../stepper/stepper.service';
import { ClientService } from 'src/app/services/client.service';
import { TenantService } from 'src/app/services/tenant.service';

@Component({
  templateUrl: './booking-preview.component.html',
  selector: 'app-booking-preview',
  styleUrls: ['./booking-preview.component.scss'],
})
export class BookingPreviewComponent implements OnDestroy, AfterViewInit, OnChanges {

  @Input("shipment") shipment: Shipment;
  @Input("senderCustomer") senderCustomer: any | undefined;
  @Input("recipientCustomer") recipientCustomer: any | undefined;

  config: AppConfig;
  subscription: Subscription;
  shipmentSubscription: Subscription;
  bookingType: any[];

  enableShipmentPrice: boolean = false;
  shipmentPrice: any;
  loadingPrice: boolean = false;

  priceErrorMessage = "";
  priceVaild = true;
  constructor(public configService: ConfigService, private readonly shipmentService: ShipmentService, private readonly auth: AuthService, private stepperService: StepperService, private clientService: ClientService, private tenantService: TenantService) {
    this.config = this.configService.config;
    this.subscription = this.configService.configUpdate$.subscribe((config) => {
      this.config = config;
    });
    if (auth.hasFeature('onlinebook_showshipmentprice') && auth.hasSetting("feat.showshipmentprice")) {
      this.enableShipmentPrice = true;
    }
    this.stepperService.UpdateChangesToCollisCreateBtn();
  }
  ngOnChanges(changes: SimpleChanges): void {
  }

  @HostListener("window:CheckPriceEvent", ["$event"])
  eventHandlerFunction(event: any) {
    if (this.auth.hasFeature('onlinebook_showshipmentprice') && this.auth.hasSetting("feat.showshipmentprice"))
      this.checkForChanges(JSON.parse(JSON.stringify(this.shipment)));
  }

  private shipmentCache: any = {};

  ngAfterViewInit() {

    this.stepperService.UpdateChangesToCollisCreateBtn();
  }

  private checkForChanges(obj1: any) {
    setTimeout(() => {
      if (this.shipment.collis && this.shipment.collis.length > 0) {
        this.loadingPrice = true;
        this.shipmentService.calculatePrice(this.shipment).subscribe((res: any) => {
          this.priceErrorMessage = "";
          if (Number.parseInt(res.currency) > 0) {
            switch (Number.parseInt(res.currency)) {
              case 1:
                this.priceErrorMessage = "ukendt felj, prøve igen feljkode: " + res.currency;
                this.priceVaild = false;
                break;
              case 2:
                this.priceErrorMessage = "zone ikke fundet feljkode: " + res.currency;
                this.priceVaild = false;
                break;
              case 4:
                this.priceErrorMessage = "interval ikke fundet feljkode: " + res.currency;
                this.priceVaild = false;
                break;
              case 8:
                this.priceErrorMessage = "colli type ikke fundet i prisblad feljkode: " + res.currency;
                this.priceVaild = false;
                break;
              case 16:
                this.priceErrorMessage = "colli oversættelse felj feljkode: " + res.currency;
                this.priceVaild = false;
                break;
              case 32:
                this.priceErrorMessage = "Kunde har ikke noget prisblad feljkode: " + res.currency;
                this.priceVaild = false;
                break;
              case 64:
                this.priceErrorMessage = "Kunde har ikke nogen services feljkode: " + res.currency;
                this.priceVaild = false;
                break;
              case 128:
              case 8192:
              case 4096:
                this.priceErrorMessage = "Kunde ikke fundet. feljkode: " + res.currency;
                this.priceVaild = false;
                break;
              case 256:
                this.priceErrorMessage = "Produkter ikke fundet i prisblad feljkode: " + res.currency;
                this.priceVaild = false;
                break;
              case 512:
                this.priceErrorMessage = "ingen pris i prisblad feljkode: " + res.currency;
                this.priceVaild = false;
                break;
              case 1024:
                this.priceErrorMessage = "ingen pris fundet til udrenging af ldm priser.feljkode: " + res.currency;
                this.priceVaild = false;
                break;
              case 2048:
                this.priceErrorMessage = "standart colli type ikke fundet. feljkode: " + res.currency;
                this.priceVaild = false;
                break;
              case 16384:
                this.priceErrorMessage = "kreditor ikke fundet. feljkode: " + res.currency;
                this.priceVaild = false;
                break;
              default:
                this.priceVaild = true;
                break;
            }
          }
          // if (isDevMode())
          //   this.shipmentPrice = this.CreateTestPriceObject();
          // else
            this.shipmentPrice = res;
          this.shipment.Price = this.shipmentPrice;          
          this.loadingPrice = false;
        });
      }
    }, 50);
  }
  // }
  // }

  private shouldGetPrice() {
    if (
      this.shipment.collis &&
      this.shipment.collis.length > 0 &&
      this.shipment.senderAddress.date &&
      this.shipment.recipientAddress.date &&
      this.shipment.senderAddress.name &&
      this.shipment.senderAddress.zipCode &&
      this.shipment.senderAddress.street &&
      this.shipment.recipientAddress.name &&
      this.shipment.recipientAddress.zipCode &&
      this.shipment.recipientAddress.street
    ) {
      return true;
    }
    return false;
  }

  getToday() {
    return new Date();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.shipmentSubscription) {
      this.shipmentSubscription.unsubscribe();
    }
  }

  deleteColli(colli: any) {
    for (let i = 0; i < this.shipment.collis.length; i++) {
      if (this.shipment.collis[i] === colli) {
        this.shipment.collis.splice(i, 1);
      }
    }
    this.stepperService.UpdateChangesToCollisCreateBtn();
    this.checkForChanges({});
  }

  GetBookingAdrTotalKg() {
    let totalKilo = 0;
    this.shipment.dangerousGoods.forEach(x => {
      totalKilo += x.grossWeightKg;
    })
    return totalKilo;
  }

  GetBookingAdrTotalPoints() {
    let totalpoints = 0;
    this.shipment.dangerousGoods.forEach(x => {
      totalpoints += x.point;
    })
    return totalpoints;
  }

  FormatTimeOnlyForHtml(value: string) {
    return value.slice(value.length - 3)
  }
  // is used to create a test price object (taken from prod from test tjw 11 )
  CreateTestPriceObject() {
    return {
      priceValid: true,
      totalPrice: 437.630,
      currency: "DKK",
      lines: [
        {
          quantity: 1.0,
          text: "Fragt",
          price: 409.00,
          totalPrice: 409.000
        },
        {
          quantity: 1.0,
          text: "Vejafgift 7.00%",
          price: 28.63,
          totalPrice: 28.630
        }
      ]
    }
  }

}
